import { signal } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { BaseComponent } from '@shared/classes';
import { FormFieldType } from '@shared/constants';
import { FormField, InputValidations } from '@shared/models';

export class ContactFormBase extends BaseComponent {
  public readonly submitted = signal(false);
  public readonly errorMessage = signal('');
  public readonly successMessage = signal('');
  public selectedOption = 'default';
  public _contactForm: FormGroup = new FormGroup({});
  public readonly FormFieldType: typeof FormFieldType = FormFieldType;
  public controlErrorMessages: Record<string, Record<string, string>> = {};

  get form(): FormGroup {
    return this._contactForm;
  }

  protected createForm(fields: FormField[]): FormGroup {
    // Init Controls
    const controls: { [key: string]: AbstractControl } = {};

    // Construct controls
    for (const field of fields) {
      const validations: ValidatorFn[] = this.constructFormValidations(
        field.formControlName,
        field.validations
      );
      controls[field.formControlName] = new FormControl(
        field.defaultValue,
        validations
      );
    }

    // init FormGroup
    return new FormGroup(controls);
  }

  protected constructFormValidations(
    formControlName: string,
    inputValidations: InputValidations[]
  ): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    for (const item of inputValidations) {
      if (item.type === 'required') {
        validators.push(Validators.required);
        if (item.message)
          this.controlErrorMessages[formControlName] = {
            ...this.controlErrorMessages[formControlName],
            [item.type]: item.message,
          };
      } else if (item.type === 'pattern') {
        validators.push(Validators.pattern(item.pattern || ''));
        if (item.message)
          this.controlErrorMessages[formControlName] = {
            ...this.controlErrorMessages[formControlName],
            [item.type]: item.message,
          };
      } else if (item.type === 'email') {
        validators.push(Validators.email);
        if (item.message)
          this.controlErrorMessages[formControlName] = {
            ...this.controlErrorMessages[formControlName],
            [item.type]: item.message,
          };
      }
    }
    return validators;
  }

  protected resetMessages(): void {
    this.errorMessage.set('');
    this.successMessage.set('');
  }
}
